import { Link, Text } from "@alpacahq/ui/old";

import type { FAQItem } from "../../../../components/common/FAQ";

export const FDIC_DEPOSIT_BANK_LIST_URL =
  "https://alpaca.markets/deposit-bank-list";

export const HIGH_YIELD_CASH_FAQ_ITEMS: FAQItem[] = [
  {
    question: "What is an FDIC Sweep program?",
    answer: (
      <Text>
        An FDIC Bank Sweep Program, is an insured deposit program that allows
        customers who opt-in to earn interest on eligible cash balances and
        offers expanded FDIC insurance coverage on those cash balances.
      </Text>
    ),
  },
  {
    question: "How does FDIC sweep work?",
    answer: (
      <Text>
        Eligible uninvested cash in a customer brokerage account can be swept to
        one or more of the participating{" "}
        <Link href={FDIC_DEPOSIT_BANK_LIST_URL}>FDIC Sweep Program Banks</Link>.
      </Text>
    ),
  },
  {
    question: "When is interest paid to my account?",
    answer: (
      <Text>
        While interest accrues daily, it is realized (credited) monthly on the
        last business day of the month. The realized interest stays invested
        within the sweep program to compound into yield unless other user
        actions are taken such as withdrawals, transfers, or trading activities
        that require cash for settlement. Realized interest for the month will
        be available in your TradingAPI Dashboard homepage and monthly account
        statement.
      </Text>
    ),
  },
  {
    question: "What do I need to qualify?",
    answer: (
      <Text>
        Alpaca may sweep available cash into the FDIC Bank Sweep up to $2.5M per
        user per day. Cash that remains unswept, including cash above that daily
        sweep threshold, may still earn shared interest under the program.
        <br /> <br />
        Additionally, accounts with a margin debit balance do not earn interest
        through the program since there is no cash balance.
      </Text>
    ),
  },
  {
    question:
      "After enrolling, how long does it take for my cash to be swept into the program?",
    answer: (
      <Text>
        Settled cash balances are swept once daily. The daily cutoff time is
        approximately 11:45 AM ET. Depending on when your funds settle, the
        sweep may occur on the same business day or the next.
      </Text>
    ),
  },
  {
    question:
      "After unenrolling, how long does it take for my cash to be swept out of the program?",
    answer: (
      <Text>
        Same-day or next business day depending on timing. The daily cutoff for
        unenrollment requests to process same-day is 12:00 pm ET.
      </Text>
    ),
  },
  {
    question: "Where can I find a list of specific banks in the program?",
    answer: (
      <Text>
        You can find the list of participating{" "}
        <Link href={FDIC_DEPOSIT_BANK_LIST_URL}>
          FDIC Sweep Program Banks on our website
        </Link>{" "}
        and in your monthly statement once enrolled.
      </Text>
    ),
  },
];
